import { render, staticRenderFns } from "./RunnitDynamicFieldLabelRow.vue?vue&type=template&id=36e97f94"
import script from "./RunnitDynamicFieldLabelRow.vue?vue&type=script&lang=ts"
export * from "./RunnitDynamicFieldLabelRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports